import { Data } from 'interfaces/ApolloResponse.interface'
import { Debtor } from '../../../containers/PersonalForm/PersonalForm.interface'

const nationalityNotDe =
  (debtor: Debtor = Debtor.PRIMARY) =>
  (state: Data): boolean =>
    state.debtors[debtor].personal.nationality !== 'DE'

export default nationalityNotDe
